// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IColorMap } from "services/ColorMap/IColorMap";
import { IColorMapService } from "services/ColorMap/IColorMapService";
import { CyclicColorMap } from "services/ColorMap/Predefined/CyclicColorMap";
import { GrayscaleColorMap } from "services/ColorMap/Predefined/GrayscaleColorMap";
import { InfernoColorMap } from "services/ColorMap/Predefined/InfernoColorMap";
import { JetColorMap } from "services/ColorMap/Predefined/JetColorMap";
import { MagmaColorMap } from "services/ColorMap/Predefined/MagmaColorMap";
import { PlasmaColorMap } from "services/ColorMap/Predefined/PlasmaColorMap";
import { ViridisColorMap } from "services/ColorMap/Predefined/ViridisColorMap";
import { IUserSettingsService } from "services/UserManagement/IUserSettingsService";

@autoinject
export class ColorMapService implements IColorMapService {
    private static userSettingsStoragGroupKey = "ColorMapService";
    private userSettingsService: IUserSettingsService;

    private defaultColorMap: IColorMap = new JetColorMap();
    private _colorMaps: IColorMap[];

    public get colorMaps(): IColorMap[] {
        return this._colorMaps;
    }

    constructor(userSettingsService: IUserSettingsService) {
        this._colorMaps = [
            new JetColorMap(),
            new MagmaColorMap(),
            new InfernoColorMap(),
            new PlasmaColorMap(),
            new ViridisColorMap(),
            new CyclicColorMap(),
            new GrayscaleColorMap(),
        ];
        this.userSettingsService = userSettingsService;
    }

    public getDefaultColorMap(key: string): Promise<IColorMap> {
        return this.userSettingsService
            .get(ColorMapService.userSettingsStoragGroupKey, key)
            .then((x) => {
                const colorMap = this.colorMaps.find((cm) => cm.name == x);
                return colorMap ? colorMap : this.defaultColorMap;
            })
            .catch(() => {
                return this.defaultColorMap;
            });
    }

    public setDefaultColorMap(key: string, colorMap: IColorMap): Promise<void> {
        return this.userSettingsService.set(ColorMapService.userSettingsStoragGroupKey, key, colorMap.name);
    }
}
